(function ($) {
  $(document).ready(function () {
    $('table').attr('cellspacing', '0');
  });
}(jQuery));
